// src/hooks/useGeolocation.js
// Hook pour la géolocalisation - NE PAS MODIFIER

import { useState, useEffect, useCallback } from 'react';

export const useGeolocation = () => {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Demander la géolocalisation
  const requestLocation = useCallback(() => {
    setLoading(true);
    setError(null);

    if (!navigator.geolocation) {
      setError('Géolocalisation non supportée par votre navigateur');
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        setLocation({ lat: latitude, lng: longitude, accuracy });
        setLoading(false);
      },
      (err) => {
        let errorMessage = 'Erreur de géolocalisation';
        switch (err.code) {
          case err.PERMISSION_DENIED:
            errorMessage = 'Autorisation de géolocalisation refusée';
            break;
          case err.POSITION_UNAVAILABLE:
            errorMessage = 'Localisation non disponible';
            break;
          case err.TIMEOUT:
            errorMessage = 'Délai d\'attente dépassé';
            break;
          default:
            break;
        }
        setError(errorMessage);
        setLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  }, []);

  // Surveiller la position en temps réel
  const watchLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setError('Géolocalisation non supportée');
      return null;
    }

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        setLocation({ lat: latitude, lng: longitude, accuracy });
        setError(null);
      },
      (err) => {
        setError('Erreur de géolocalisation en temps réel');
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
      }
    );

    return watchId;
  }, []);

  // Arrêter de surveiller
  const stopWatching = useCallback((watchId) => {
    if (watchId && navigator.geolocation) {
      navigator.geolocation.clearWatch(watchId);
    }
  }, []);

  // Charger la localisation au montage si possible
  useEffect(() => {
    // On demande pas automatiquement pour respecter la vie privée
    // L'utilisateur doit cliquer sur un bouton
  }, []);

  return {
    location,
    error,
    loading,
    requestLocation,
    watchLocation,
    stopWatching,
    isAvailable: !!navigator.geolocation,
  };
};